<template>
  <b-modal
    id="delete-folder-modal"
    title="Are you sure you want to delete this folder?"
    name="delete-folder-modal"
    ref="deletefoldermodal"
    size="lg"
    :busy="loading"
    ok-title="Delete"
    close-title="Cancel"
    hide-header-close
    @ok="handleOk">
    This will also delete all folders and requirements inside this folder
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Deleting
    </div>
  </b-modal>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        loading: false
      }
    },
    props: {
      folderId: Number
    },
    mixins: [utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        this.loading = true
        this.submitData()
      },
      submitData () {
        this.$ga.event('folder', 'delete', this.folderId, 1)
        this.$http.delete(
          '/api/folder/' + this.folderId,
          {}
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Folder deleted successfully',
            type: 'success',
            close: 'auto'
          })
          this.loading = false
          this.setTheState()
          this.$refs.deletefoldermodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem deleting your folder: ${errorString}`,
            type: 'error'
          })
          this.loading = false
        })
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshItemsList', true)
        this.$store.commit('setCurrentItem', null)
        this.$store.commit('clearSelectedRequirements')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteFolderModal.vue?090dcb91